export default __webpack_public_path__ + "static/media/s3-bg-2x.798634b5.png";